export const UPDATE_VESTING_TIMEOUT = 10000;
